<template lang="pug">
v-dialog(
  :value='value.opened'
  transition='slide-x-reverse-transition'
  hide-overlay
  fullscreen
  persistent
  lazy
)
  v-card
    v-toolbar(color='primary' class='toolbar' dark flat)
      v-btn(icon @click.native='close')
        v-icon close
      v-toolbar-title Редактор генплана
      v-spacer
      v-btn(@click='complete' flat)
        v-icon(left) done
        | Сохранить изменения
    div(class='app-workspace')
      genplan-leaflet(v-model='value' ref='genplan')
</template>

<script>
import GenplanLeaflet from './GenplanLeaflet'
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: { GenplanLeaflet },

  methods: {
    getGenplanInstance() {
      return this.$refs.genplan
    },

    close() {
      this.$emit('input', {
        ...this.value,
        opened: false
      })
    },

    complete() {
      this.$emit('complete', this.value.objects)
    }
  }
}
</script>

<style scoped>
.app-workspace {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
}
.toolbar {
  z-index: 10;
}
</style>
